const API_BASE_URL = import.meta.env.VITE_API_URL || '';
const FOJAS_BASE_URL = `${API_BASE_URL}/api/fojas`;

function headers() {
  const result = {};
  try {
    const token = localStorage.getItem('token');
    const rawTenant = localStorage.getItem('tenant');
    if (token) result.Authorization = `Bearer ${token}`;
    if (rawTenant) {
      try {
        const tenant = JSON.parse(rawTenant);
        result['X-Tenant'] = tenant?.code || tenant?.domain || rawTenant;
      } catch {
        result['X-Tenant'] = rawTenant;
      }
    }
  } catch { /* storage may be unavailable */ }
  return result;
}

export async function fetchFojaPdf(fojaId, { download = false } = {}) {
  const response = await fetch(`${FOJAS_BASE_URL}/${fojaId}/pdf${download ? '?download=1' : ''}`, { headers: headers(), credentials: 'include' });
  if (!response.ok) {
    let message = 'No se pudo generar el PDF de la foja.';
    try { message = (await response.json())?.message || message; } catch { /* keep default */ }
    throw new Error(message);
  }
  return response.blob();
}

export async function printFojaPdf(fojaId) {
  // This must remain synchronous with the user click. `noopener` may make some
  // browsers return a null WindowProxy even though they created the tab.
  const popup = window.open('', '_blank');
  if (!popup) throw new Error('El navegador bloqueó la ventana de impresión.');
  try {
    const blob = await fetchFojaPdf(fojaId);
    const url = URL.createObjectURL(blob);
    popup.opener = null;
    popup.location.href = url;
    popup.focus();
    popup.addEventListener('beforeunload', () => window.setTimeout(() => URL.revokeObjectURL(url), 1000), { once: true });
  } catch (error) {
    popup.close();
    throw error;
  }
}
